/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAmmo
 */
export interface OutputAmmo {
    /**
     * 
     * @type {string}
     * @memberof OutputAmmo
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAmmo
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAmmo
     */
    name: string;
}

/**
 * Check if a given object implements the OutputAmmo interface.
 */
export function instanceOfOutputAmmo(value: object): boolean {
    if (!('description' in value)) return false;
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputAmmoFromJSON(json: any): OutputAmmo {
    return OutputAmmoFromJSONTyped(json, false);
}

export function OutputAmmoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAmmo {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputAmmoToJSON(value?: OutputAmmo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'id': value['id'],
        'name': value['name'],
    };
}

